import { useEffect, useMemo } from "react";
import ReactDatePicker from "react-datepicker";
import { ProductAvailability } from "../../../../graphql/operations";
import { formatDate } from "../../../../utils/calendarUtils";
interface SumoCalendarProps {
  availability: ProductAvailability[];
  setSelectedDate: Function;
  selectedDate: Date;
}

const FULL_DATE_CLASSNAME = "react-datepicker__full" as const;

export default function SumoCalendar({
  availability,
  selectedDate,
  setSelectedDate,
}: SumoCalendarProps) {
  const includeDates = useMemo(
    () =>
      availability
        .filter((a) => a.status === "AVAILABLE")
        .map((b) => {
          return new Date(
            new Date(b.date).toLocaleString("en-US", { timeZone: "Asia/Tokyo" })
          );
        }),
    [availability]
  );

  const handleDatePickerChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  useEffect(() => {
    if (!selectedDate) {
      setSelectedDate(includeDates[0]);
    }
  }, [selectedDate, includeDates, setSelectedDate]);

  const getDayClassName = (date) => {
    const notAvailableDays = availability.filter(
      (a) => a.status === "NOT_AVAILABLE" && a.timeSlots.length > 0
    );
    const timeZoneDate = formatDate(
      new Date(date.toLocaleString("en-US", { timeZone: "Asia/Tokyo" }))
    );

    const isDayFull =
      notAvailableDays.find((d) => d.date === timeZoneDate) &&
      !availability
        .filter((a) => a.status === "AVAILABLE")
        .find((d) => d.date === timeZoneDate);
    if (isDayFull) {
      return FULL_DATE_CLASSNAME;
    }
  };

  return (
    <div className="ReservationDatepicker">
      <ReactDatePicker
        inline={true}
        includeDates={includeDates}
        onChange={handleDatePickerChange}
        selected={selectedDate}
        dateFormat="MMM dd, yyyy"
        dayClassName={(date) => getDayClassName(date)}
      />
    </div>
  );
}
